import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Modal, message } from 'ui';
import { useCreateAbuseReportMutation } from 'features/report';

export const useReportEvent = () => {
  const { t } = useTranslation();
  const [modal, contextHolder] = Modal.useModal();
  const { mutateAsync: reportEvent } = useCreateAbuseReportMutation();

  const confirm = useCallback(
    ({ event }: { event: { id: string; name: string } }) => {
      const handleReportEvent = async () => {
        await reportEvent(
          { contentObjectId: event.id },
          {
            onSuccess() {
              message.success('Event has been reported to admins of your organization.');
            },
          },
        );
      };

      modal.confirm({
        content: 'We will notify admins of your organization',
        icon: <Icon color="info" icon="flag-1-line" />,
        okText: 'Report',
        onOk: handleReportEvent,
        title: t('Are you sure you want to report {{name}}?', { name: event.name }),
      });
    },
    [modal, reportEvent, t],
  );

  return useMemo(() => ({ confirm, contextHolder }), [confirm, contextHolder]);
};
